import React, {createContext, ReactNode, useEffect, useState} from 'react'
import {getSheetsSyncByProcess} from '../../../services/fichas'
import {DetailModal} from './detail-modal/DetailModal'

export interface IAssignmentDetail {
  fieldId: string
  fieldLabel: string
  infoAssignments: {
    assignTo: string
    isReadable: boolean
    isWritable: boolean
  }
  ficha: {
    id: string
    nombre: string
  }
  proceso: {
    id: string
    nombre: string
  }
  seccion: {
    id: string
    nombre: string
  }
}

export interface IField {
  id: string
  label: string
  type: string
  identifier: string
  createdBy: string
  assignmentCount: number
  assignmentDetails: IAssignmentDetail[]
}

export interface IData {
  abbr: string
  label: string
  fields: IField[]
}

export type IDataFields = Omit<IField, 'assignmentDetails' | 'assignmentCount'>

export interface IData2 {
  abbr: string
  label: string
  fields: IDataFields[]
}

export interface EntityByProcessContextType {
  data: IData[]
  setData: (data: IData[]) => void
  dataFields: IData2[]
  setDataFields: (dataFields: IData2[]) => void
  fieldSelected: string
  setFieldSelected: (fieldSelected: string) => void
  detailField: {
    field: string
    details: IAssignmentDetail[]
  }
  setDetailField: React.Dispatch<
    React.SetStateAction<{field: string; details: IAssignmentDetail[]}>
  >
  showModal: boolean
  setShowModal: (showModal: boolean) => void
  change: boolean
  setChange: (change: boolean) => void
  fetchData: () => void
}

export const EntityByProcessContext = createContext<EntityByProcessContextType>({
  data: [],
  setData: () => {},
  dataFields: [],
  setDataFields: () => {},
  fieldSelected: 'all',
  setFieldSelected: () => {},
  detailField: {
    field: '',
    details: [],
  },
  setDetailField: () => {},
  showModal: false,
  setShowModal: () => {},
  change: false,
  setChange: () => {},
  fetchData: () => {},
})

export const EntityByProcessProvider = ({children}: {children: ReactNode}) => {
  const [fieldSelected, setFieldSelected] = useState('all')
  const [data, setData] = useState<IData[]>([])
  const [dataFields, setDataFields] = useState<IData2[]>([])
  const [detailField, setDetailField] = useState<{field: string; details: IAssignmentDetail[]}>({
    field: '',
    details: [],
  })
  const [showModal, setShowModal] = useState(false)
  const [change, setChange] = useState(false)

  useEffect(() => {
    fetchData()
  }, [fieldSelected])

  const fetchData = () => {
    getSheetsSyncByProcess(fieldSelected)
      .then((response) => {
        if (response.success) {
          setData(response?.data ?? [])
          setDataFields(response?.dataFields ?? [])
        }
      })
      .catch(console.log)
  }

  return (
    <EntityByProcessContext.Provider
      value={{
        data,
        setData,
        dataFields,
        setDataFields,
        fieldSelected,
        setFieldSelected,
        detailField,
        setDetailField,
        showModal,
        setShowModal,
        change,
        setChange,
        fetchData,
      }}
    >
      {children}
      <DetailModal />
    </EntityByProcessContext.Provider>
  )
}
